import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Dialog, DialogContent } from '../components/ui/dialog';
import { X, Building2 } from 'lucide-react';

// Photos de nos installations / Our facilities
const facilityImages = [
  {
    url: "https://customer-assets.emergentagent.com/job_beauty-wellness-spot/artifacts/tb48693x_IMG-20260105-WA0023.jpg",
    title_pt: "Nosso Salão",
    title_en: "Our Salon",
    title_fr: "Notre Salon",
    title_de: "Unser Salon",
    title_es: "Nuestro Salón"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_beauty-wellness-spot/artifacts/6ofd3nn2_IMG-20260105-WA0025.jpg",
    title_pt: "Estação de Tranças",
    title_en: "Braiding Station",
    title_fr: "Station de Tressage",
    title_de: "Flechtstation",
    title_es: "Estación de Trenzas"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_beauty-wellness-spot/artifacts/r9hbn78h_IMG-20241125-WA0031.jpg",
    title_pt: "Sala Wellness",
    title_en: "Wellness Room",
    title_fr: "Salle Wellness",
    title_de: "Wellness-Raum",
    title_es: "Sala Wellness"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_beauty-wellness-spot/artifacts/vpso01w1_IMG-20241231-WA0020.jpg",
    title_pt: "Espaço Beauty",
    title_en: "Beauty Space",
    title_fr: "Espace Beauté",
    title_de: "Beauty-Bereich",
    title_es: "Espacio Beauty"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_beauty-wellness-spot/artifacts/sofkgnd3_IMG-20241231-WA0022.jpg",
    title_pt: "Área de Lavagem",
    title_en: "Washing Area",
    title_fr: "Zone de Lavage",
    title_de: "Waschbereich",
    title_es: "Área de Lavado"
  },
];

const galleryImages = [
  {
    url: "https://customer-assets.emergentagent.com/job_7f45736e-df57-4742-9820-4e4efb4e31c0/artifacts/o3nki2nn_1_20260124_200727_0000.png",
    category: "services",
    title_pt: "Menu de Serviços",
    title_en: "Services Menu",
    title_fr: "Menu des Services",
    title_de: "Dienstleistungsmenü",
    title_es: "Menú de Servicios"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_7f45736e-df57-4742-9820-4e4efb4e31c0/artifacts/jiywv4db_3_20260124_130601_0002.png",
    category: "services",
    title_pt: "Serviços Afro Hair & Beauty",
    title_en: "Afro Hair & Beauty Services",
    title_fr: "Services Afro Hair & Beauté",
    title_de: "Afro Hair & Beauty Services",
    title_es: "Servicios Afro Hair & Belleza"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_7f45736e-df57-4742-9820-4e4efb4e31c0/artifacts/2acm0n3r_4_20260124_130601_0003.png",
    category: "spa",
    title_pt: "Kamit's Facial Care & Massagens",
    title_en: "Kamit's Facial Care & Massages",
    title_fr: "Soins Visage & Massages Kamit",
    title_de: "Kamit's Gesichtspflege & Massagen",
    title_es: "Cuidado Facial & Masajes Kamit"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_7f45736e-df57-4742-9820-4e4efb4e31c0/artifacts/pt65l8sm_5_20260124_130601_0004.png",
    category: "spa",
    title_pt: "Kamit's Body Care & Spa Formulas",
    title_en: "Kamit's Body Care & Spa Formulas",
    title_fr: "Soins Corporels & Formules Spa Kamit",
    title_de: "Kamit's Körperpflege & Spa-Formeln",
    title_es: "Cuidado Corporal & Fórmulas Spa Kamit"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_7f45736e-df57-4742-9820-4e4efb4e31c0/artifacts/5nzxh0f8_6_20260124_200727_0005.png",
    category: "about",
    title_pt: "Contacto IPRBC KAMIT",
    title_en: "Contact IPRBC KAMIT",
    title_fr: "Contact IPRBC KAMIT",
    title_de: "Kontakt IPRBC KAMIT",
    title_es: "Contacto IPRBC KAMIT"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_beauty-wellness-spot/artifacts/kaxbu8b6_Trancista%20trainings%20.jpg",
    category: "training",
    title_pt: "Formação Trancista",
    title_en: "Braiding Training"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_beauty-wellness-spot/artifacts/ytty1xxi_Mani%20trainings%20.jpg",
    category: "training",
    title_pt: "Formação Manicure",
    title_en: "Manicure Training"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_beauty-wellness-spot/artifacts/8fmg5id3_Cera%20trainings%20.jpg",
    category: "training",
    title_pt: "Formação Depilação",
    title_en: "Waxing Training"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_beauty-wellness-spot/artifacts/k8s0f4rl_Massage%20trainings.jpg",
    category: "training",
    title_pt: "Formação Massagem",
    title_en: "Massage Training"
  },
];

const categories = [
  { key: 'all', label_pt: 'Todos', label_en: 'All', label_fr: 'Tous', label_de: 'Alle', label_es: 'Todos' },
  { key: 'services', label_pt: 'Serviços', label_en: 'Services', label_fr: 'Services', label_de: 'Dienstleistungen', label_es: 'Servicios' },
  { key: 'spa', label_pt: 'Spa', label_en: 'Spa', label_fr: 'Spa', label_de: 'Spa', label_es: 'Spa' },
  { key: 'afro', label_pt: 'Afro Hair', label_en: 'Afro Hair', label_fr: 'Afro Hair', label_de: 'Afro Hair', label_es: 'Afro Hair' },
  { key: 'training', label_pt: 'Formações', label_en: 'Training', label_fr: 'Formations', label_de: 'Ausbildung', label_es: 'Formación' },
];

const GalleryPage = () => {
  const { language } = useLanguage();
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedImage, setSelectedImage] = useState(null);

  const filteredImages = selectedCategory === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === selectedCategory);

  const getFacilityTitle = (img) => {
    switch(language) {
      case 'fr': return img.title_fr;
      case 'de': return img.title_de;
      case 'pt': return img.title_pt;
      case 'es': return img.title_es;
      default: return img.title_en;
    }
  };

  const getCategoryLabel = (cat) => {
    switch(language) {
      case 'fr': return cat.label_fr;
      case 'de': return cat.label_de;
      case 'pt': return cat.label_pt;
      case 'es': return cat.label_es;
      default: return cat.label_en;
    }
  };

  return (
    <div className="min-h-screen bg-kamit-beige pt-20" data-testid="gallery-page">
      {/* Hero */}
      <section className="py-20 bg-kamit-brown">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-heading text-5xl md:text-6xl text-kamit-beige mb-4">
            {language === 'fr' ? 'Galerie' : language === 'de' ? 'Galerie' : language === 'pt' ? 'Galeria' : language === 'es' ? 'Galería' : 'Gallery'}
          </h1>
          <p className="text-kamit-beige/70 text-lg">
            {language === 'fr'
              ? 'Découvrez nos espaces et services'
              : language === 'de'
              ? 'Entdecken Sie unsere Räume und Dienstleistungen'
              : language === 'pt'
              ? 'Conheça os nossos espaços e serviços'
              : language === 'es'
              ? 'Descubra nuestros espacios y servicios'
              : 'Discover our spaces and services'
            }
          </p>
        </div>
      </section>

      {/* Découvrez nos installations / Discover Our Facilities */}
      <section className="py-16 bg-kamit-cream">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="flex items-center justify-center gap-3 mb-4">
              <Building2 className="h-8 w-8 text-kamit-gold" />
              <h2 className="font-heading text-3xl md:text-4xl text-kamit-brown">
                {language === 'fr' ? 'Découvrez Nos Installations' : language === 'de' ? 'Entdecken Sie Unsere Einrichtungen' : language === 'pt' ? 'Descubra as Nossas Instalações' : language === 'es' ? 'Descubra Nuestras Instalaciones' : 'Discover Our Facilities'}
              </h2>
            </div>
            <div className="w-24 h-1 bg-kamit-gold mx-auto" />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {facilityImages.map((image, index) => (
              <div
                key={index}
                onClick={() => setSelectedImage(image)}
                className="relative group cursor-pointer overflow-hidden rounded-2xl shadow-lg aspect-square"
              >
                <img
                  src={image.url}
                  alt={getFacilityTitle(image)}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-kamit-brown/80 via-transparent to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <p className="text-kamit-beige font-medium text-center">
                    {getFacilityTitle(image)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Filter */}
      <section className="py-8 bg-white border-b border-kamit-brown/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h3 className="text-center font-heading text-2xl text-kamit-brown mb-6">
            {language === 'fr' ? 'Plus de Photos' : language === 'de' ? 'Mehr Fotos' : language === 'pt' ? 'Mais Fotos' : language === 'es' ? 'Más Fotos' : 'More Photos'}
          </h3>
          <div className="flex flex-wrap justify-center gap-3">
            {categories.map((cat) => (
              <button
                key={cat.key}
                onClick={() => setSelectedCategory(cat.key)}
                className={`px-6 py-2 rounded-full transition-all ${
                  selectedCategory === cat.key
                    ? 'bg-kamit-brown text-kamit-beige'
                    : 'bg-kamit-cream text-kamit-brown hover:bg-kamit-brown/10 border border-kamit-brown/20'
                }`}
                data-testid={`filter-${cat.key}`}
              >
                {getCategoryLabel(cat)}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filteredImages.map((image, index) => (
              <div
                key={index}
                onClick={() => setSelectedImage(image)}
                className="relative group cursor-pointer overflow-hidden rounded-xl aspect-square"
                data-testid={`gallery-image-${index}`}
              >
                <img
                  src={image.url}
                  alt={language === 'pt' ? image.title_pt : image.title_en}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-kamit-dark/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <p className="text-kamit-beige font-medium">
                    {language === 'pt' ? image.title_pt : image.title_en}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      <Dialog open={!!selectedImage} onOpenChange={() => setSelectedImage(null)}>
        <DialogContent className="max-w-4xl p-0 bg-transparent border-none">
          <div className="relative">
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute top-4 right-4 z-10 p-2 bg-kamit-dark/50 rounded-full text-white hover:bg-kamit-dark"
            >
              <X className="h-6 w-6" />
            </button>
            {selectedImage && (
              <img
                src={selectedImage.url}
                alt={language === 'pt' ? selectedImage.title_pt : selectedImage.title_en}
                className="w-full h-auto rounded-lg"
              />
            )}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default GalleryPage;
